import { FC } from 'react'

import InputItem from '../../../components/InputItem'
import { ITabBaseProps } from '../types'
import { DISPOSAL_RATE_ERROR } from '../utils'

export const WasteDisposalSplit: FC<ITabBaseProps> = ({ formik }) => {
  return (
    <div className="mb-5">
      <div className="piece-content-inputs">
        <InputItem
          name="Data source comment"
          description=""
          type="text"
          formik={formik}
          onChange={formik.handleChange}
          formikName="disposalDataSourceComment"
          defaultValue={formik.values.disposalDataSourceComment ?? ''}
        />
      </div>
      <h4 className="mb-2 font-semibold">Incineration</h4>
      <div className="piece-content-inputs">
        <InputItem
          name="Incineration rate"
          description="Share of the non-recycled waste disposed of this way."
          type="input"
          addonTitle="%"
          formik={formik}
          onChange={formik.handleChange}
          formikName="disposalIncinerationRate"
          defaultValue={formik.values.disposalIncinerationRate ?? ''}
        />
      </div>
      <h4 className="mb-2 mt-6 font-semibold">Landfill</h4>
      <div className="piece-content-inputs">
        <InputItem
          name="Landfill rate"
          description="Share of the non-recycled waste disposed of this way."
          type="input"
          addonTitle="%"
          formik={formik}
          onChange={formik.handleChange}
          formikName="disposalLandfillRate"
          defaultValue={formik.values.disposalLandfillRate ?? ''}
        />
      </div>
      {formik.touched.disposalLandfillRate &&
        formik.errors.disposalLandfillRate === DISPOSAL_RATE_ERROR && (
          <p className="text-color-rose-500 mt-2">{DISPOSAL_RATE_ERROR}</p>
        )}
    </div>
  )
}
